import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/business-and-communications")({
  head: () => buildRouteHead("/en/services/business-and-communications", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/about-qbd", replace: true });
  },
});
